import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * @param requireRole   "master" | "tenant" | "owner"
 * @param requireModule "sales_stock" — pakete bağlı modül erişimi (şartname #10).
 *                      Modül pasifse kullanıcı panoya yönlendirilir; API tarafı
 *                      ayrıca 403 döndürür (iki katmanlı koruma).
 */
export default function ProtectedRoute({ children, requireRole, requireModule }) {
  const { user, loading, salesStockEnabled } = useAuth();

  if (loading || user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-background"
        data-testid="auth-loading"
      >
        <Loader2 className="h-8 w-8 animate-spin text-foreground" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Master users only allowed inside /master/*
  if (requireRole === "master" && user.role !== "master") {
    return <Navigate to="/" replace />;
  }
  if (requireRole === "tenant" && user.role === "master") {
    return <Navigate to="/master" replace />;
  }
  if (requireRole === "owner" && !(user.role === "owner" || user.role === "master")) {
    return <Navigate to="/" replace />;
  }
  if (requireModule === "sales_stock" && !salesStockEnabled) {
    return <Navigate to="/" replace />;
  }

  return children;
}
